export default "__VITE_ASSET__CYBcrwyU__"